import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';

export function createUserOrganizationWithDistrictSelectOption(
  userOrganization: IUserOrganisation,
): IUserOrganisationSelectOption {
  return {
    ...userOrganization,
    label: `${districtsToString(userOrganization)} ${userOrganization.fullName}`,
    value: userOrganization.id,
    districtName: userOrganization.districtName,
    districtId: userOrganization.districtId,
  };
}

function districtsToString(userOrganization: IUserOrganisation) {
  if (
    userOrganization.ervkUuid &&
    userOrganization.prosecutorDistricts != null &&
    userOrganization.prosecutorDistricts.length > 0
  ) {
    return `${userOrganization.prosecutorDistricts.map(district => district.name).join(', ')}, `;
  }

  return `${userOrganization.districtName ? `${userOrganization.districtName}, ` : ''}${userOrganization.fullName}`;
}
